<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchTournament } from '@/api/games/tournament';


export default {
    name: "tournament-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchTournament,
        }
    }
}
</script>
